import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6625">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6626">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6627">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6628">
            <ArrowLeft className="w-4 h-4" data-id="element-6629" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6630">NOIZA</div>
          <div className="w-20" data-id="element-6631" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6632">
        <div className="mb-12" data-id="element-6633">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6634">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6635" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6636">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6637">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6638">
          <section data-id="element-6639">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6640">
              <span className="text-[#006847]" data-id="element-6641">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6642">
              <p data-id="element-6643">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6644">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6645">
                <li data-id="element-6646">Haber leído íntegramente este documento</li>
                <li data-id="element-6647">Comprender su contenido en su totalidad</li>
                <li data-id="element-6648">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6649">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6650">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6651">
              <span className="text-[#006847]" data-id="element-6652">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6653">
              <p data-id="element-6654">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6655">
                <li data-id="element-6656">Software como servicio (SaaS)</li>
                <li data-id="element-6657">Marketplace digital gastronómico</li>
                <li data-id="element-6658">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6659">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6660">
                <li data-id="element-6661">Mostrar su menú digital</li>
                <li data-id="element-6662">Recibir pedidos de clientes</li>
                <li data-id="element-6663">Gestionar su operación interna</li>
                <li data-id="element-6664">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6665">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6666">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6667">
              <span className="text-[#006847]" data-id="element-6668">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6669">
              <p data-id="element-6670">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6671">
                <li data-id="element-6672">No es proveedor de alimentos</li>
                <li data-id="element-6673">No participa en la preparación de productos</li>
                <li data-id="element-6674">No manipula alimentos en ningún momento</li>
                <li data-id="element-6675">No realiza entregas ni logística</li>
                <li data-id="element-6676">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6677">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6678">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6679">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6680">
              <span className="text-[#006847]" data-id="element-6681">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6682">
              <p data-id="element-6683">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6684">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6685">
                <li data-id="element-6686">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6687">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6688">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6689">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6690">
                <li data-id="element-6691">Precios</li>
                <li data-id="element-6692">Menú</li>
                <li data-id="element-6693">Horarios</li>
                <li data-id="element-6694">Métodos de pago</li>
                <li data-id="element-6695">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6696">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6697">
              <span className="text-[#006847]" data-id="element-6698">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6699">
              <div data-id="element-6700">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6701">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6702">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6703">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6704">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6705">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6706">
                  <li data-id="element-6707">Calidad de los alimentos</li>
                  <li data-id="element-6708">Estado, frescura o preparación</li>
                  <li data-id="element-6709">Ingredientes utilizados</li>
                  <li data-id="element-6710">Contaminación cruzada</li>
                  <li data-id="element-6711">Problemas de higiene o salubridad</li>
                  <li data-id="element-6712">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6713">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6714">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6715">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6716">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6717">
                  <li data-id="element-6718">Retrasos en la entrega</li>
                  <li data-id="element-6719">Pérdida de pedidos</li>
                  <li data-id="element-6720">Entregas incompletas</li>
                  <li data-id="element-6721">Errores en dirección</li>
                  <li data-id="element-6722">Conducta de repartidores</li>
                  <li data-id="element-6723">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6724">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6725">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6726">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6727">
                  <li data-id="element-6728">Recepción de pagos</li>
                  <li data-id="element-6729">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6730">Manejo de efectivo</li>
                  <li data-id="element-6731">Confirmación de pagos</li>
                  <li data-id="element-6732">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6733">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6734">
                  <li data-id="element-6735">Pagos no recibidos</li>
                  <li data-id="element-6736">Comprobantes falsos</li>
                  <li data-id="element-6737">Errores en montos</li>
                  <li data-id="element-6738">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6739">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6740">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6741">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6742">
                  <li data-id="element-6743">Reclamos de clientes</li>
                  <li data-id="element-6744">Reembolsos</li>
                  <li data-id="element-6745">Cancelaciones</li>
                  <li data-id="element-6746">Disputas</li>
                  <li data-id="element-6747">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6748">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6749">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6750">
              <span className="text-[#006847]" data-id="element-6751">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6752">
              <p data-id="element-6753">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6754">
                <li data-id="element-6755">Responsable</li>
                <li data-id="element-6756">Legal</li>
                <li data-id="element-6757">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6758">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6759">
                <li data-id="element-6760">Publicar información falsa</li>
                <li data-id="element-6761">Manipular precios de forma engañosa</li>
                <li data-id="element-6762">Simular disponibilidad inexistente</li>
                <li data-id="element-6763">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6764">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6765">
              <span className="text-[#006847]" data-id="element-6766">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6767">
              <p data-id="element-6768">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6769">
                <li data-id="element-6770">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6771">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6772">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6773">
                <li data-id="element-6774">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6775">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6776">
                    <li data-id="element-6777">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6778">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6779">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6780">
              <span className="text-[#006847]" data-id="element-6781">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6782">
              <p data-id="element-6783">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6784">
                <li data-id="element-6785">Menú digital</li>
                <li data-id="element-6786">Gestión de pedidos</li>
                <li data-id="element-6787">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6788">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6789">
                  <p className="font-medium text-white mb-2" data-id="element-6790">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6791">
                    <li data-id="element-6792">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6793">
                  <p className="font-medium text-white mb-2" data-id="element-6794">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6795">
                    <li data-id="element-6796">Propiedad del software</li>
                    <li data-id="element-6797">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6798">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6799">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6800">
              <span className="text-[#006847]" data-id="element-6801">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6802">
              <p data-id="element-6803">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6804">
                <li data-id="element-6805">Disponibilidad continua</li>
                <li data-id="element-6806">Funcionamiento sin interrupciones</li>
                <li data-id="element-6807">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6808">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6809">
                <li data-id="element-6810">Fallas técnicas</li>
                <li data-id="element-6811">Actualizaciones</li>
                <li data-id="element-6812">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6813">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6814">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6815">
              <span className="text-[#006847]" data-id="element-6816">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6817">
              <p data-id="element-6818">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6819">
                <li data-id="element-6820">No está garantizada permanentemente</li>
                <li data-id="element-6821">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6822">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6823">
                <li data-id="element-6824">Destacar o no restaurantes</li>
                <li data-id="element-6825">Modificar posiciones</li>
                <li data-id="element-6826">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6827">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6828">
              <span className="text-[#006847]" data-id="element-6829">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6830">
              <p data-id="element-6831">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6832">
                <li data-id="element-6833">Cumplir con los pagos acordados</li>
                <li data-id="element-6834">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6835">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6836">
                <li data-id="element-6837">Suspender el servicio</li>
                <li data-id="element-6838">Limitar funcionalidades</li>
                <li data-id="element-6839">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6840">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6841">
              <span className="text-[#006847]" data-id="element-6842">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6843">
              <p data-id="element-6844">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6845">
                <li data-id="element-6846">Incumplimiento de términos</li>
                <li data-id="element-6847">Uso indebido</li>
                <li data-id="element-6848">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6849">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6850">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6851">
              <span className="text-[#006847]" data-id="element-6852">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6853">
              <p data-id="element-6854">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6855">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6856">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6857">
              <span className="text-[#006847]" data-id="element-6858">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6859">
              <p data-id="element-6860">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6861">
                <li data-id="element-6862">Pérdidas económicas</li>
                <li data-id="element-6863">Daños indirectos</li>
                <li data-id="element-6864">Lucro cesante</li>
                <li data-id="element-6865">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6866">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6867">
              <span className="text-[#006847]" data-id="element-6868">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6869">
              <p data-id="element-6870">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6871">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6872">
              <span className="text-[#006847]" data-id="element-6873">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6874">
              <p className="font-medium" data-id="element-6875">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6876">
                <li data-id="element-6877">Ha leído este documento completo</li>
                <li data-id="element-6878">Comprende su alcance</li>
                <li data-id="element-6879">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}